module.exports = __webpack_public_path__ + "static/media/producer-down-icon.ea1451e7.svg";